import React from 'react';

const Impressum = () => (
  <div className="bg-gray-50 min-h-screen py-16 px-4 md:px-10 lg:px-20 text-gray-800 font-light">
    <div className="max-w-4xl mx-auto bg-white shadow-md rounded-xl p-8 md:p-12 space-y-6">
      <h1 className="text-4xl font-bold text-main mb-6 border-b pb-4">
        Impressum
      </h1>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg">
          Angaben gemäß § 5 TMG
        </h2>

        <p>
          Arabische Schule in Braunschweig Annour e.V.
          <br />
          Petzvalstr. 50
          <br />
          38104 Braunschweig
        </p>
        <p>
          Vertreten durch:
          <br />
          1. Vorsitzender: Dr. Abdulghani Albadawi
          <br />
          Stellvertretender Vorsitzender: Dr. Yaser Daaboul
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg">Kontakt</h2>
        <p>
          Telefon und WhatsApp: +49 152 594 315 15
          <br />
          E-Mail:{' '}
          <a
            href="mailto:info@annour-bs.de"
            className="text-blue-600 underline"
          >
            info@annour-bs.de
          </a>
          <br />
          Web:{' '}
          <a
            href="https://www.annour-bs.de"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            www.annour-bs.de
          </a>
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg">Registereintrag</h2>
        <p>
          Eingetragen im Vereinsregister
          <br />
          Registergericht: Amtsgericht Braunschweig
          <br />
          Registernummer: VR 201399
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg">Streitschlichtung</h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung (OS) bereit:{' '}
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            https://ec.europa.eu/consumers/odr
          </a>
          .
        </p>
        <p>
          Unsere E-Mail-Adresse finden Sie oben im Impressum.
          <br />
          Wir sind nicht bereit oder verpflichtet, an
          Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg">Haftung für Inhalte</h2>
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
          Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
          verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
          Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
          gespeicherte fremde Informationen zu überwachen oder nach
          Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
          hinweisen.
        </p>
        <p>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
          Informationen nach den allgemeinen Gesetzen bleiben hiervon
          unberührt. Eine diesbezügliche Haftung ist jedoch erst ab
          dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
          möglich. Bei Bekanntwerden von entsprechenden
          Rechtsverletzungen werden wir diese Inhalte umgehend
          entfernen.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg">Haftung für Links</h2>
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter,
          auf deren Inhalte wir keinen Einfluss haben. Deshalb können
          wir für diese fremden Inhalte auch keine Gewähr übernehmen.
        </p>
        <p>
          Für die Inhalte der verlinkten Seiten ist stets der
          jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
          Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung
          nicht erkennbar. Eine permanente inhaltliche Kontrolle der
          verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte
          einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
          Rechtsverletzungen werden wir derartige Links umgehend
          entfernen.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="font-semibold text-lg">Urheberrecht</h2>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke
          auf diesen Seiten unterliegen dem deutschen Urheberrecht.
          Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
          der Verwertung außerhalb der Grenzen des Urheberrechtes
          bedürfen der schriftlichen Zustimmung des jeweiligen Autors
          bzw. Erstellers.
        </p>
        <p>
          Downloads und Kopien dieser Seite sind nur für den privaten,
          nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte
          auf dieser Seite nicht vom Betreiber erstellt wurden, werden
          die Urheberrechte Dritter beachtet.
        </p>
        <p>
          Sollten Sie trotzdem auf eine Urheberrechtsverletzung
          aufmerksam werden, bitten wir um einen entsprechenden
          Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir
          derartige Inhalte umgehend entfernen.
        </p>
      </section>
    </div>
  </div>
);

export default Impressum;
